export class CustomerBrandingDTO{
    public id!: number;
    public customerId!: number;
    public brandName!: string;
    public businessDisplayName!: string;
    public primaryColor!: string;
    public filePath!: string;
}